/**
 * Labstep
 *
 * @module constants/form
 * @desc List of fields for form
 */

export enum FieldType {
  Text = 'Text',
  ProseMirrorHtml = 'ProseMirrorHtml',
  ReactSelect = 'ReactSelect',
  File = 'File',
  DateTimePicker = 'DateTimePicker',
  TextArea = 'TextArea',
  SearchSelect = 'SearchSelect',
  SelectMulti = 'SelectMulti',
  SelectOptions = 'SelectOptions',
  Checkbox = 'Checkbox',
  Radio = 'Radio',
  action = 'action',
}
